// DS: MO0.8
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { useTranslation } from 'react-i18next';
import Points from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { formatDollars } from '../utils/formatting';
import s from './PointsCard.scss';
const PointsCard = ({ pointsAmount, price, subproductId, isPopular, className, biData })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Section, {
        className: classnames(s['root'], isPopular && s['popular'], className)
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['popular-note']
    }, t('common.points.popular')), /*#__PURE__*/ React.createElement(Heading, {
        className: s['points-root']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['points-amount']
    }, /*#__PURE__*/ React.createElement(Points, {
        size: IconSize.MEDIUM
    }), Intl.NumberFormat('en-US').format(pointsAmount)), /*#__PURE__*/ React.createElement("span", {
        className: s['points-label']
    }, t('common.points'))), /*#__PURE__*/ React.createElement(SolidButton, {
        size: "large",
        variant: "approval-green",
        className: s['cta'],
        href: Url.checkoutLink(subproductId),
        biData: biData
    }, formatDollars(`${price}`)));
};
PointsCard.displayName = 'PointsCard';
export default PointsCard;

//# sourceMappingURL=PointsCard.js.map